import {sendInvites} from "../../actions/users";

const SendInvite = (props) => {
  const {
    name,
    id,
    item,
    currentUser,
    sendAction
  } = props;

  return (
    <button
      name={name}
      id={id}
      className='send-invite-button'
      onClick={(e) => {
        e.preventDefault();

        sendAction(currentUser, item);
      }}
    />
  );
}

export default SendInvite;